import { Button, FormGroup, Grid, Input, InputLabel, TextField, Typography } from '@mui/material';
import { navigate } from '@reach/router';
import Network, { ServiceEndpoint } from 'common/network';
import SwitchInput from 'components/form/switchInput';
import TextInput from 'components/form/textInput';
import SureDialog from 'pages/messages/components/sureDialog';
import * as React from 'react';
import { IOnlineUserDto } from '../../../common/responses/IOnlineUserDto';

export interface UserInfoProps {
	bidderId: string;
	user: IOnlineUserDto;
	handleInputChange: (event: any) => void;
}

const UserInfo: React.FunctionComponent<UserInfoProps> = (props) => {
	const { user } = props;
	const [showDialog, setShowDialog] = React.useState(false);
	const [showVerifyDialog, setShowVerifyDialog] = React.useState(false);
	const [showPasswordDialog, setShowPasswordDialog] = React.useState(false);
	const [password, setPassword] = React.useState('Holstebro1234');

	const handleDelete = async () => {
		await Network.delete(ServiceEndpoint.User, `bidder/${props.bidderId}`);
		navigate('/users', { replace: true });
	};

	const handleVerifyEmail = async () => {
		await Network.post(ServiceEndpoint.User, `bidder/${props.bidderId}/verify-email`, {});
		window.location.reload();
	};

	const handlePasswordReset = async () => {
		await Network.put(ServiceEndpoint.User, `bidder/${props.bidderId}/password`, { password });
	};

	return (
		<React.Fragment>
			<Grid container spacing={4}>
				<Grid item xs={4}>
					<Typography gutterBottom variant="h6">
						Kontaktoplysninger
					</Typography>
					<FormGroup>
						<InputLabel htmlFor="name">Navn</InputLabel>
						<FormGroup row={true}>
							<Input
								id="name"
								name="firstName"
								value={user.firstName}
								onChange={props.handleInputChange}
							/>
							<Input id="name" name="lastName" value={user.lastName} onChange={props.handleInputChange} />
						</FormGroup>
						<TextInput
							label="Firma navn"
							name="companyName"
							object={user}
							onChange={props.handleInputChange}
						/>
						<TextInput label="Adresse" name="streetName" object={user} onChange={props.handleInputChange} />
						<TextInput label="Provins" name="province" object={user} onChange={props.handleInputChange} />
						<TextInput
							label="Post nummer"
							name="postalCode"
							object={user}
							onChange={props.handleInputChange}
						/>
						<TextInput label="By" name="city" object={user} onChange={props.handleInputChange} />
						<TextInput label="Land" name="country" object={user} onChange={props.handleInputChange} />
						<TextInput
							label="Telefon nummer"
							name="phoneNumber"
							object={user}
							onChange={props.handleInputChange}
						/>
						<TextInput label="E-mail" name="email" object={user} onChange={props.handleInputChange} />
					</FormGroup>
				</Grid>
				<Grid item>
					<Typography gutterBottom variant="h6">
						Bruger administration
					</Typography>

					<Typography variant="subtitle1">
						Her kan du blokere brugere fra at kunne byde. Brugeren vil stadig kunne se kataloger.
					</Typography>
					<FormGroup>
						<SwitchInput
							label={'Blokeret'}
							name="blocked"
							object={user}
							onChange={props.handleInputChange}
						/>
					</FormGroup>

					<Typography style={{ marginTop: '1em' }} variant="subtitle1">
						{user.emailVerified === undefined
							? 'E-mailens Cognito-verifikationsstatus kunne ikke hentes.'
							: `E-mail er ${user.emailVerified ? 'verificeret' : 'ikke verificeret'} i Cognito.`}
					</Typography>
					{user.emailVerified === false && (
						<Button style={{ marginTop: '0.5em' }} variant="outlined" onClick={() => setShowVerifyDialog(true)}>
							Markér e-mail som verificeret
						</Button>
					)}

					<Typography style={{ marginTop: '1em' }} variant="subtitle1">
						Nulstil adgangskode
					</Typography>
					<TextField
						fullWidth
						label="Ny adgangskode"
						type="password"
						value={password}
						onChange={(event) => setPassword(event.target.value)}
					/>
					<Button
						style={{ marginTop: '0.5em' }}
						variant="outlined"
						disabled={password.length < 8}
						onClick={() => setShowPasswordDialog(true)}
					>
						Nulstil adgangskode
					</Button>

					<Button style={{ marginTop: '1em' }} variant="outlined" onClick={() => setShowDialog(true)}>
						Slet bruger
					</Button>
					<Typography style={{ marginTop: '1em' }} variant="subtitle2">
						Vær opmærksom på at brugerens bud ikke slettes. Det er udelukkende personlige data, og bruger
						profilen der forsvinder.
					</Typography>
				</Grid>
			</Grid>

			<SureDialog
				open={showDialog}
				body="Vil du slette brugeren?"
				acceptMessage="Slet"
				handleClose={(perform) => {
					setShowDialog(false);
					if (!perform) {
						return;
					}

					handleDelete();
				}}
			/>
			<SureDialog
				open={showVerifyDialog}
				body="Vil du markere brugerens e-mail som verificeret i Cognito?"
				acceptMessage="Verificér e-mail"
				handleClose={(perform) => {
					setShowVerifyDialog(false);
					if (perform) {
						handleVerifyEmail();
					}
				}}
			/>
			<SureDialog
				open={showPasswordDialog}
				body="Vil du nulstille brugerens adgangskode til den angivne værdi?"
				acceptMessage="Nulstil adgangskode"
				handleClose={(perform) => {
					setShowPasswordDialog(false);
					if (perform) {
						handlePasswordReset();
					}
				}}
			/>
		</React.Fragment>
	);
};

export default UserInfo;
